import { Initialable } from './app-init.service';

import { Injectable } from '@angular/core';

import { File } from '@awesome-cordova-plugins/file/ngx';
import { Platform } from '@ionic/angular';
import { StorageService } from './storage.service';

import { EasyDebugDecorator } from '../../app/decorators/easy-debug.decorator';

@Injectable({ providedIn: 'root' })
@Initialable({ step: `init3`, initializer: `init` })
@EasyDebugDecorator
export class AssetsService {
  constructor(
    public file: File,
    public platform: Platform,
    private storageService: StorageService
  ) {}

  async init() {
    if (this.platform.is('cordova')) {
      await this.cleanOfflineRemnant();
    }
    await this.deleteStorageKeys();
    return 'Assets done';
  }

  async cleanOfflineRemnant() {
    await this.deleteDirs();
  }

  async deleteDirs(): Promise<any> {
    await this.deleteDir('Imgs');
    await this.deleteDir('Audios');
    await this.deleteDir('Videos');
    return;
  }

  async deleteDir(name: string): Promise<any> {
    const dirExist = await this.checkDir(name);
    if (!dirExist) {
      await this.file.removeRecursively(this.file.dataDirectory, name);
    }
    return;
  }

  async checkDir(dir: string): Promise<boolean> {
    const isPresent = await this.file
      .checkDir(this.file.dataDirectory, dir)
      .catch(() => {
        return false;
      });
    return isPresent;
  }

  async deleteStorageKeys(): Promise<any> {
    const keysToDelete = ['-downloadedSeries', '-dlList', '-rmList'];
    const keys = await this.storageService.keys();
    for (const key of keys) {
      if (keysToDelete.includes(key)) {
        await this.storageService.remove(key);
      }
    }
    return;
  }
}
